import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=f85d2eda&"
import script from "./DeleteAccount.vue?vue&type=script&lang=ts&"
export * from "./DeleteAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports